import i18n from '@/i18n/i18n';

export default [
  {
    url: '/dashboard',
    name: i18n.t('common_word.dashboard'),
    icon: 'mdi-view-dashboard-outline',
    acl: 'loggedIn',
  },
  {
    url: '/admin/businesses',
    name: i18n.t('model.business.plural'),
    icon: 'mdi-domain',
    acl: 'admin',
  },
  {
    url: '/admin/bookings',
    name: i18n.t('common_word.quescreen_history'),
    icon: 'mdi-file-document-outline',
    acl: 'admin',
  },
  {
    url: '/admin/question-groups',
    name: i18n.t('model.question_group.plural'),
    icon: 'mdi-help-circle-outline',
    acl: 'allowQuestionGroupCRUD',
  },
  {
    url: '/admin/risk-profile-templates',
    name: i18n.t('model.risk_profile_template.plural'),
    icon: 'mdi-file-compare',
    acl: 'allowRiskProfileTemplateCRUD',
  },
  {
    name: i18n.t('model.business.my'),
    icon: 'mdi-domain',
    acl: 'business',
    items: [
      {
        url: '/business/update',
        name: i18n.t('model.business.details'),
      },
      {
        url: '/business/credit-check',
        name: i18n.t('model.business.apply_for_credit_check'),
        // todo: improve display rules
        display_rules: [
          {
            module: 'Auth',
            state: 'activeBusiness',
            attribute: 'active_business_credit_check',
            operator: 'equals',
            value: null,
          },
        ],
      },
      {
        url: '/business/api-credentials',
        name: i18n.t('model.business.api_credentials'),
        acl: 'allowOAuthCRUD',
      },
    ],
  },
  {
    name: i18n.t('model.risk_profile.plural'),
    icon: 'mdi-file-compare',
    acl: 'business',
    items: [
      {
        url: '/business/risk-profiles/create',
        name: i18n.t('model.risk_profile.create'),
      },
      {
        url: '/business/risk-profiles/list',
        name: i18n.t('model.risk_profile.list'),
      },
    ],
  },
  {
    name: i18n.t('model.booking.plural'),
    icon: 'mdi-file-document-box',
    acl: 'business',
    items: [
      {
        url: '/business/bookings/create',
        name: i18n.t('model.booking.create'),
      },
      {
        url: '/business/bookings/list',
        name: i18n.t('model.booking.list'),
      },
    ],
  },
  {
    name: i18n.t('model.purchase_quescreen.purchase'),
    icon: 'mdi-credit-card-outline',
    acl: 'business',
    items: [
      {
        url: '/business/service-orders/create',
        name: i18n.t('model.purchase_quescreen.new'),
      },
      {
        url: '/business/service-orders/list',
        name: i18n.t('model.purchase_quescreen.history'),
      },
    ],
  },
  {
    url: '/admin/booking-candidates',
    name: i18n.t('model.booking_candidate.candidate_list_admin'),
    icon: 'mdi-file-document-box',
    acl: 'admin',
  },
  {
    url: '/business/booking-candidates',
    name: i18n.t('model.booking_candidate.candidate_list_business'),
    icon: 'mdi-file-document-box',
    acl: 'business',
  },
  {
    url: '/candidate/update',
    name: 'My Details',
    icon: 'mdi-account',
    acl: 'candidate',
  },
  {
    url: '/candidate/booking-candidates',
    name: i18n.t('model.booking_candidate.candidate_list'),
    icon: 'mdi-file-document-box',
    acl: 'candidate',
  },
  {
    url: '/admin/users',
    name: i18n.t('common_word.users'),
    icon: 'mdi-account-multiple',
    acl: 'admin',
  },
  // {
  //   url: '/candidate/profile',
  //   name: i18n.t('model.candidate_profile.navmenu'),
  //   icon: 'mdi-clipboard-account',
  //   acl: 'candidate',
  // },
  // {
  //   url: '/candidate/service-orders',
  //   name: i18n.t('model.service_order.plural'),
  //   icon: 'mdi-credit-card-outline',
  //   acl: 'candidate',
  // },
  {
    url: '/admin/service-candidates',
    name: i18n.t('model.service_candidate.plural'),
    icon: 'mdi-account-plus',
    acl: 'serviceCandidateProcess',
  },
  {
    url: '/admin/business-credit-checks',
    name: i18n.t('model.business_credit_check.plural'),
    icon: 'mdi-check-circle-outline',
    acl: 'admin',
  },
  {
    name: i18n.t('model.purchase_quescreen.purchase'),
    icon: 'mdi-credit-card-outline',
    acl: 'admin',
    items: [
      {
        url: '/admin/service-orders/create',
        name: i18n.t('model.purchase_quescreen.new'),
      },
      {
        url: '/admin/service-orders/list',
        name: i18n.t('model.purchase_quescreen.history'),
      },
    ],
  },
  {
    url: '/admin/service-payments-report',
    name: i18n.t('model.purchase_quescreen.report'),
    icon: 'mdi-chart-line',
    acl: 'admin',
  },
];
